import { Directive, HostListener } from '@angular/core';

const NUMBER_REGEX = /[^0-9]/;
const EXCEPT_NUMBER_REGEX = /\D+/g;

@Directive({
  selector: '[appOnlyNumbers]',
})
export class OnlyNumbersDirective {

  constructor() {}
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const key = event.key;
    if (key >= '0' && key <= '9') {
      return;
    }
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'];
    if (allowedKeys.includes(key)) {
      return;
    }
    if ((event.ctrlKey || event.metaKey) && ['a', 'c', 'v', 'x'].includes(key.toLowerCase())) {
      return;
    }
    event.preventDefault();
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement | null;
    if (!input) {
      return;
    }
    const sanitized = input.value.replace(EXCEPT_NUMBER_REGEX, '');
    if (sanitized !== input.value) {
      input.value = sanitized;
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const pastedText = event.clipboardData?.getData('text');
    if (pastedText && NUMBER_REGEX.test(pastedText)) {
      event.preventDefault();
    }
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent) {
    const textData = event.dataTransfer?.getData('text');
    if (textData && NUMBER_REGEX.test(textData)) {
      event.preventDefault();
    }
  }
}
